import { render, staticRenderFns } from "./BrandsFilter.vue?vue&type=template&id=108c9d8d&"
import script from "./BrandsFilter.vue?vue&type=script&lang=js&"
export * from "./BrandsFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports